import React from 'react';

const TicketActionButton = ({onClick, label, color}) => {
    return (
        <button
            onClick={onClick}
            className={`inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 mr-2 ${color}`}
        >
            {label}
        </button>
    );
};

export default TicketActionButton;